import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { ClientDetail } from '~/features/ClientDetail';
import { ClientDetailHeader } from '~/features/ClientDetailHeader';
import { LegacyClientDetail } from '~/features/LegacyClientDetail';
import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';

type Props = {
  clientId: number;
};

export const ClientShowScreenContent: React.FC<Props> = ({ clientId }) => {
  const { enableStaging } = getEnvFeatureFlag();

  return (
    <Suspense fallback={<Loader />}>
      {/* enableStaging が ON（staging / development）のときのみ新コンポーネントを表示 */}
      {enableStaging && <ClientDetailHeader id={clientId} />}
      {enableStaging ? <ClientDetail id={clientId} /> : <LegacyClientDetail id={clientId} />}
    </Suspense>
  );
};
